// App settings — adjustable text size. The three type sizes (foot/body/heading)
// track --fs-base; the largest level is 15px (the original), the default is two
// steps down (13px). Persisted per browser.
import { writable } from 'svelte/store';

export const FONT_LEVELS = [11, 12, 13, 14, 15];   // body px; last = largest
export const FONT_DEFAULT = 13;                    // two steps down from the largest
const KEY = 'admin.fsBase';

function init(): number {
  try { const v = Number(localStorage.getItem(KEY)); if (FONT_LEVELS.includes(v)) return v; } catch (_) { /* ignore */ }
  return FONT_DEFAULT;
}

export const fontBase = writable<number>(init());
fontBase.subscribe((v) => {
  try { localStorage.setItem(KEY, String(v)); } catch (_) { /* ignore */ }
  try { document.documentElement.style.setProperty('--fs-base', v + 'px'); } catch (_) { /* ignore */ }
});

// ── Colour theme for the GENERATED app ────────────────────────────────────
// This is NOT the admin console's colour — it's the accent baked into the web app a
// project generates/exports. Persisted here and emitted into generated code.
export interface Theme { id: string; label: string; accent: string; accent2: string; on: string; }
export const THEMES: Theme[] = [
  { id: 'blue',   label: 'Light Blue', accent: '#5EA0FF', accent2: '#8CBEFF', on: '#05121F' },
  { id: 'teal',   label: 'Teal',       accent: '#20B7AE', accent2: '#5FD8D0', on: '#03201E' },
  { id: 'violet', label: 'Violet',     accent: '#8B79FF', accent2: '#B4A6FF', on: '#0F0A1F' },
  { id: 'green',  label: 'Green',      accent: '#35B877', accent2: '#6FD3A1', on: '#03200F' },
  { id: 'amber',  label: 'Amber',      accent: '#E0A93E', accent2: '#F0C976', on: '#201604' },
  { id: 'rose',   label: 'Rose',       accent: '#EC5586', accent2: '#F58FB0', on: '#1F0610' },
];
export const themeById = (id: string): Theme => THEMES.find((t) => t.id === id) ?? THEMES[0];

// ── Templates (the output target a project generates / exports to) ────────
export interface Template { id: string; label: string; desc: string; icon: string; ready: boolean; }
export const TEMPLATES: Template[] = [
  { id: 'svelte', label: 'Svelte',      desc: 'Generate Svelte 5 pages wired to the real app components.', ready: true,  icon: 'M8 9l-3 3 3 3M16 9l3 3-3 3M13.5 6l-3 12' },
  { id: 'npm',    label: 'npm package', desc: 'Scaffold a runnable Vite + npm project bundle.',            ready: true,  icon: 'M3 7l9-4 9 4-9 4-9-4zM3 7v10l9 4 9-4V7M12 11v10' },
  { id: 'react',  label: 'React',       desc: 'Generate React (JSX) components.',                          ready: false, icon: 'M12 11.2a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6zM12 7c5 0 9 2.2 9 5s-4 5-9 5-9-2.2-9-5 4-5 9-5zM8 5.7c2.5-4.3 6-6.6 8.5-5.2s2.3 5.6-.2 9.9M8 17.6c-2.5 4.3-2.7 8.5-.2 9.9' },
  { id: 'html',   label: 'Static HTML', desc: 'Plain HTML / CSS / JS — no framework.',                     ready: false, icon: 'M6 3h9l4 4v14H6zM15 3v4h4M9 12l-2 2 2 2M14 12l2 2-2 2' },
];
export const templateById = (id: string): Template => TEMPLATES.find((t) => t.id === id) ?? TEMPLATES[0];
